export const SET_ALL_PAYMENT_METHODS_DATA_LOADING = "SET_ALL_PAYMENT_METHODS_DATA_LOADING";
export const SET_PAYMENT_METHODS_DATA = "SET_PAYMENT_METHODS_DATA";
export const SET_COMPANY_PAYMENT_METHODS_DATA_LOADING = "SET_COMPANY_PAYMENT_METHODS_DATA_LOADING";
export const SET_COMPANY_PAYMENT_METHODS_DATA = "SET_COMPANY_PAYMENT_METHODS_DATA";
export const SET_ALL_PAYMENT_SETTINGS_DATA_LOADING = "SET_ALL_PAYMENT_SETTINGS_DATA_LOADING";
export const SET_PAYMENT_SETTINGS_DATA = "SET_PAYMENT_SETTINGS_DATA";
export const CLEAR_PAYMENT_METHODS_DATA = "CLEAR_PAYMENT_METHODS_DATA";

